define([
	"./_Flip",
	"./PluginFactory"
], function(_Flip, PluginFactory) {

	return PluginFactory.declare(_Flip, {
		bHorizontal: true,
		iconClass: "csiActionIcon svgIconFlipHorizontal",
		pluginName: "flipHorizontal",
		title: "CanvasFlipHorizontal"
	});
});
